import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { apiPaths } from "../../../../service/apiPaths";
import ApiService from "../../../../service/ApiService";
import { IAddTestSeries, ITestSeries } from "../../TestSeries.props";
import { SubmitHandler } from "react-hook-form";
import toast from "react-hot-toast";

const useEditTestSeries = (testSeriesId: string) => {
  const [formData, setFormData] = useState<IAddTestSeries>({
    testSeriesName: "",
    languageName: "",
    courseName: "",
    standard: "",
    config: [],
    duration: 0,
    amount: 0,
    isPaid: false, // Default to Free
  });
  const [loading, setLoading] = useState<boolean>(false);
  const [testSeries, setTestSeries] = useState<ITestSeries | null>(null);
  const [courses, setCourses] = useState<any[]>([]);
  const [languages, setLanguages] = useState<any[]>([]);
  const [subjectName, setSubjectName] = useState<any[]>([]);
  const [standard, setStandard] = useState<any[]>([]);
  const navigate = useNavigate();

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await ApiService({
        method: "GET",
        endpoint: apiPaths.getTestSeriesById + '/' + testSeriesId,
      });
      console.log("API response:-----------------", response);
      if (response) {
        setTestSeries(response.data);
        populateFormData(response.data);
      } else {
        toast.error("No test series data found.");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      toast.error("Failed to load test series data.");
    } finally {
      setLoading(false);
    }
  };


  const populateFormData = (testSeriesData: IAddTestSeries) => {
    setFormData({
      testSeriesName: testSeriesData.testSeriesName,
      languageName: testSeriesData.languageName,
      courseName: testSeriesData.courseName,
      config: testSeriesData.config,
      duration: testSeriesData.duration,
      standard: testSeriesData.standard,
      amount: testSeriesData.amount,
      isPaid: testSeriesData.isPaid ?? false, // Default to Free if not set
    });
  };
  const handleChange = (
    e: React.ChangeEvent<HTMLSelectElement | HTMLInputElement>
  ) => {
    const { id, type, value } = e.target;

    if (type === "file") {
      const files = (e.target as HTMLInputElement).files;

      if (files && files.length > 0) {
        setFormData((prev) => ({
          ...prev,
          [id]: files[0],
        }));
      }
    } else {
      setFormData((prev) => ({
        ...prev,
        [id]: value,
      }));
    }
  };

  const fetchCoursesAndLanguages = async () => {
    try {
      setLoading(true);
      const [
        coursesResponse,
        languagesResponse,
        subjectResponse,
        standardResponse,
      ] = await Promise.all([
        ApiService({ method: "GET", endpoint: apiPaths.getCourse }),
        ApiService({ method: "GET", endpoint: apiPaths.getlanguage }),
        ApiService({ method: "GET", endpoint: apiPaths.getSubject }),
        ApiService({ method: "GET", endpoint: apiPaths.getStandard }),
      ]);

      setCourses(coursesResponse || []);
      setLanguages(languagesResponse || []);
      setSubjectName(subjectResponse || []);
      setStandard(standardResponse || []);

      if (!coursesResponse.length || !languagesResponse.length) {
        toast.error("No data found for courses or languages.");
      }
    } catch (error) {
      console.error("Error fetching courses and languages:", error);
      toast.error("Failed to fetch courses or languages."); // Show error toast
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit: SubmitHandler<IAddTestSeries> = async (data) => {
    setLoading(true);
    const formData = new FormData();
    Object.entries(data).forEach(([key, value]) => {
      formData.append(key, value);
    });
    try {
      const response = await ApiService({
        method: "PUT",
        endpoint: `${apiPaths.updateTestSeries}/${testSeriesId}`,
        data: formData,
      });

      if (response !== "undefined") {
        toast.success("TestSeries updated successfully", {
          duration: 10000,
        });
        window.location.href = "/test-series";
      }
    } catch (error) {
      toast.error("Error updating status", {
        duration: 10000,
      });
      console.error("Error updating testSeries:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (testSeriesId) {
      fetchData();
      fetchCoursesAndLanguages();
    }
  }, [testSeriesId]);

  const handleCancel = () => {
    window.location.reload();
  };

  return {
    loading,
    formData,
    testSeries,
    languages,
    courses,
    subjectName,
    standard,
    handleChange,
    handleSubmit,
    handleCancel,

  };
};

export default useEditTestSeries;
